import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LoaderSpinner from "../../component/LoaderSpinner";
import ReactHtmlParser from "react-html-parser";
import FacebookShare from "../SocialMediaShare/FacebookShare";
import TwitterShare from "../SocialMediaShare/TwitterShare";

export default function BlogDetails(props) {
  const [blogDetail, setBlogDetail] = useState([]);
  const [previousBlog, setPreviousBlog] = useState([]);
  const [nextBlog, setNextBlog] = useState([]);
  const [recentBlog, setRecentBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const id = props.match.params.id;
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    window.scrollTo(0, 0);
    axios.post("api/get_blog_detail", { id: id }, { signal: controller.signal }).then((res) => {
      if (!isMounted) return; //Guard skip state if unmounted
      if (res.data.status == "success") {
        setBlogDetail(res.data.data[0]);
        setRecentBlog(res.data.recentblog);
        setPreviousBlog(res.data.previousblog[0]);
        setNextBlog(res.data.nextblog[0]);
      } else {
        setBlogDetail([]);
        setRecentBlog([]);
        setPreviousBlog([]);
        setNextBlog([]);
      }
      setLoading(false);
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError"  && error.name !== "CanceledError") {
        console.error("Failed to load blog details:", error);
        setLoading(false);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [id]);
  return (
    <div className="relative py-8 md:py-14">
      {loading ? (
        <LoaderSpinner />
      ) : (
        // <div className="container mx-auto">
        //   <div className="px-3 sm:px-6 lg:px-8 ">
        //     <img
        //       src={blogDetail.image}
        //       className="h-52 w-full object-contain"
        //     />
        //     <div className="grid md:grid-cols-12 gap-5 mt-8">
        //       <div className="col-span-12 md:col-span-8 xl:col-span-9">
        //         <div className="content mb-3">
        //           <div className="category-title">
        //             <span className="text-sm text-white bg-primary block w-max p-1 rounded-sm">
        //               {blogDetail.created_at}
        //             </span>
        //             <h2 className="font-medium text-dark-secondary text-2xl font-bold mt-5">
        //               {blogDetail.title}
        //             </h2>
        //           </div>
        //         </div>
        //         <div className="bg-white p-5 rounded-lg shadow-lg text-justify text-write text-sm">
        //           {ReactHtmlParser(blogDetail.content)}
        //         </div>
        //         <div className="flex flex-col sm:flex-row sm:items-center justify-between my-5">
        //           <div className="social_share">
        //             <label className="inline-block mr-3">Share on : </label>
        //             <div className="social_icons">
        //               <FacebookShare
        //                 url={blogDetail.share_url}
        //                 quote={blogDetail.title}
        //               />
        //               <TwitterShare
        //                 url={blogDetail.share_url}
        //                 title={blogDetail.title}
        //               />
        //               {/* <a className="icon">
        //               <i className="fa fa-facebook" />
        //             </a>
        //             <a className="icon">
        //               <i className="fa fa-twitter" />
        //             </a> */}
        //             </div>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // </div>

        <div className="section-full  p-t120 p-b90 bg-white">
          <div className="container">
            <div className="section-content">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-8 col-md-12">
                  <div className="blog-post-single-outer">
                    <div className="blog-post-single bg-white">
                      <div className="wt-post-info">
                        <div className="wt-post-media m-b10">
                          <img src={blogDetail.image} alt="" />
                        </div>

                        <div className="wt-post-title">
                          <div className="wt-post-meta-list">
                            <div className="wt-list-content post-date">
                              {blogDetail.created_at}
                            </div>
                            {blogDetail.author != null ? (
                              <div className="wt-list-content post-author">
                                By {blogDetail.author}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <h3 className="post-title">{blogDetail.title}</h3>
                        </div>

                        <div className="wt-post-discription">
                          {ReactHtmlParser(blogDetail.content)}
                          {/* <p>
                            Please make sure you understand what rights you are
                            claiming before you submit a DMCA takedown notice
                            because it is a serious legal document. Consider
                            whether you need legal advice. It's really important
                            not to make false claims as this could have serious
                            legal consequences.
                          </p>

                          <p>
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Integer tristique elit lobortis purus
                            bibendum, quis dictum metus mattis. Phasellus
                            posuere felis sed eros porttitor mattis. Curabitur
                            massa magna, tempor in blandit id, porta in ligula.
                            Aliquam laoreet nisl massa, at interdum mauris
                            sollicitudin et.Harvel is a copyright protection
                            platform for next-gen creators, crawling the web on
                            a daily basis in order to find piracy links and
                            copyright infringement of your content. I
                          </p>

                          <h2>About Business Network</h2>

                          <p>
                            Phasellus enim magna, varius et commodo ut,
                            ultricies vitae velit. Ut nulla tellus, eleifend
                            euismod and pellentesque vel, sagittis vel justo. In
                            libero urna, venenatis sit amet ornare non, suscipit
                            nec risus. Sed consequat justo non mauris pretium at
                            tempor justo sodales.
                          </p>

                          <h3>Get Your Resume Done Right</h3>

                          <p>
                            Phasellus enim magna, varius et commodo ut,
                            ultricies vitae velit. Ut nulla tellus, eleifend
                            euismod and pellentesque vel, sagittis vel justo. In
                            libero urna, venenatis sit amet ornare non, suscipit
                            nec risus. Sed consequat justo non mauris pretium at
                            tempor justo sodales.
                          </p>
                          <ul>
                            <li>
                              You need to create an account to find the best and
                              preferred job.
                            </li>
                            <li>
                              After creating the account, you have to apply for
                              the desired job.
                            </li>
                            <li>
                              After filling all the relevant information you
                              have to upload your resume.
                            </li>
                          </ul>
                          <h4>You need to create an account</h4>
                          <p>
                            penatibus et magnis dis parturient montes, nascetur
                            ridiculus mus. Integer tristique elit lobortis purus
                            bibendum, quis dictum metus mattis. Phasellus
                            posuere felis sed eros porttitor mattis. Curabitur
                            massa magna, tempor in blandit id, porta in ligula.
                            Aliquam laoreet nisl massa, at interdum mauris
                            sollicitudin et.Harvel is a copyright protection
                            platform for next-gen creators, crawling the web on
                            a daily basis in order to find piracy links and
                            copyright infringement of your content. I
                          </p>

                          <h5>This is H5 tag Title</h5>

                          <ol>
                            <li>
                              You need to create an account to find the best and
                              preferred job.
                            </li>
                            <li>
                              After creating the account, you have to apply for
                              the desired job.
                            </li>
                            <li>
                              After filling all the relevant information you
                              have to upload your resume.
                            </li>
                          </ol> */}
                        </div>
                      </div>
                    </div>

                    <div className="post-area-tags-wrap">
                      <div className="post-social-icons-wrap">
                        <span className="share_ttl">Share :</span>

                        {/* <ul className="post-social-icons">
                          <li> */}
                        <FacebookShare
                          url={blogDetail.share_url}
                          quote={blogDetail.title}
                        />
                        {/* </li>
                          <li> */}
                        <TwitterShare
                          url={blogDetail.share_url}
                          title={blogDetail.title}
                        />
                        {/* </li>
                        </ul> */}
                      </div>
                    </div>
                    {/* <div className="post-area-tags-wrap">
                      <div className="post-social-icons-wrap">
                        <span className="share_ttl">Share :</span>

                        <ul className="post-social-icons">
                          <li>
                            <a
                              href="javascript:void(0);"
                              className="fab fa-facebook-f"
                            ></a>
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              className="fab fa-twitter"
                            ></a>
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              className="fab fa-linkedin-in"
                            ></a>
                          </li>
                          <li>
                            <a
                              href="javascript:void(0);"
                              className="fab fa-google"
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                    <div className="post-navigation m-t30">
                      <div className="post-nav-links">
                        {previousBlog ? (
                          <div className="post-nav-item nav-post-prev">
                            <div className="nav-post-arrow">
                              <Link to={`/blog/${previousBlog.id}`}>
                                <i className="fa fa-angle-left"></i>
                              </Link>
                            </div>
                            <div className="nav-post-meta">
                              <Link to={`/blog/${previousBlog.id}`}>
                                {previousBlog.title}
                              </Link>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {nextBlog ? (
                          <div className="post-nav-item nav-post-next">
                            <div className="nav-post-arrow">
                              <Link to={`/blog/${nextBlog.id}`}>
                                <i className="fa fa-angle-right"></i>
                              </Link>
                            </div>
                            <div className="nav-post-meta">
                              <Link to={`/blog/${nextBlog.id}`}>
                                {nextBlog.title}
                              </Link>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-12 rightSidebar">
                  <div className="side-bar">
                    {/* <div className="widget all_services_list">
                      <h4 className="section-head-small mb-4">Categories</h4>
                      <div className="all_services m-b30">
                        <ul>
                          <li>
                            <a href="job-detail.html">Categories</a>{" "}
                            <span className="badge">08</span>
                          </li>
                          <li>
                            <a href="job-detail.html">Education</a>{" "}
                            <span className="badge">12</span>
                          </li>
                          <li>
                            <a href="job-detail.html">Information</a>
                            <span className="badge">15</span>
                          </li>
                          <li>
                            <a href="job-detail.html">Jobs</a>
                            <span className="badge">25</span>
                          </li>
                          <li>
                            <a href="job-detail.html">Learn</a>
                            <span className="badge">36</span>
                          </li>
                          <li>
                            <a href="job-detail.html">Skill</a>
                            <span className="badge">12</span>
                          </li>
                        </ul>
                      </div>
                    </div> */}

                    <div className="widget recent-posts-entry">
                      <h4 className="section-head-small mb-4">
                        Recent Article
                      </h4>
                      <div className="section-content">
                        <div className="widget-post-bx">
                          {recentBlog.length > 0
                            ? recentBlog.map((sj) => (
                                <div className="widget-post clearfix">
                                  <div className="wt-post-media">
                                    <img src={sj.image} alt={sj.title} />
                                  </div>
                                  <div className="wt-post-info">
                                    <div className="wt-post-header">
                                      <span className="post-date">
                                        {sj.created_at}
                                      </span>
                                      <span className="post-title">
                                        <Link to={`/blog/${sj.id}`}>
                                          {sj.title}
                                        </Link>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : ""}
                          {/* <div className="widget-post clearfix">
                            <div className="wt-post-media">
                              <img src="uploads/blog_image/2.jpg" alt="" />
                            </div>
                            <div className="wt-post-info">
                              <div className="wt-post-header">
                                <span className="post-date">
                                  April 12, 2023
                                </span>
                                <span className="post-title">
                                  <a href="blog-single.html">
                                    Advanced Service Functions by Air Transport
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="widget-post clearfix">
                            <div className="wt-post-media">
                              <img src="uploads/blog_image/3.jpg" alt="" />
                            </div>
                            <div className="wt-post-info">
                              <div className="wt-post-header">
                                <span className="post-date">
                                  April 15, 2023
                                </span>
                                <span className="post-title">
                                  <a href="blog-single.html">
                                    Proper arrangement for keeping the goods in
                                    the warehouse
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="widget-post clearfix">
                            <div className="wt-post-media">
                              <img src="uploads/blog_image/4.jpg" alt="" />
                            </div>
                            <div className="wt-post-info">
                              <div className="wt-post-header">
                                <span className="post-date">
                                  April 18, 2023
                                </span>
                                <span className="post-title">
                                  <a href="blog-single.html">
                                    Equipment you can count on. People you can
                                    trust.
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="widget-post clearfix">
                            <div className="wt-post-media">
                              <img src="uploads/blog_image/5.jpg" alt="" />
                            </div>
                            <div className="wt-post-info">
                              <div className="wt-post-header">
                                <span className="post-date">
                                  April 20, 2023
                                </span>
                                <span className="post-title">
                                  <a href="blog-single.html">
                                    Proper arrangement for keeping the goods in
                                    the warehouse
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>

                    {/* <div className="widget tw-sidebar-tags-wrap">
                      <h4 className="section-head-small mb-4">Tags</h4>

                      <div className="tagcloud">
                        <a href="job-list.html">General</a>
                        <a href="job-list.html">Jobs </a>
                        <a href="job-list.html">Payment</a>
                        <a href="job-list.html">Application </a>
                        <a href="job-list.html">Work</a>
                        <a href="job-list.html">Recruiting</a>
                        <a href="job-list.html">Employer</a>
                        <a href="job-list.html">Income</a>
                        <a href="job-list.html">Tips</a>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
